import path from "path";
import Login from "../components/login/login";
import Dashboard from "./About";
import LandingPage from "./Home";
// import SomeOtherPage from "./Home";
import NotFoundPage from "./Not-Found";
import SessionTimeout from "../components/login/session-timeout";

const generalRoutes = [
    { path: "/login", element: <Login /> },
    { path: "/session-timeout", element: <SessionTimeout /> },
    { path: "/dashboard", element: <Dashboard /> },
    // { path: "/other-page", element: <SomeOtherPage /> },
    { path: "/landing-page", element: <LandingPage /> },
];

export default generalRoutes;
